import { responsesStore } from "../stores/Responses";
import { findResponse } from '../utils/FormFunctions';

export function deleteAppliance(appliance: any) {
    const { responses, addResponse } = responsesStore.getState(); 
    const appliances = findResponse(responses, 'appliances');
    const newAppliances = appliances.filter((app) => app.id !== appliance.id);

    addResponse({ id: 'appliances', value: newAppliances });
}

export function updateOffGrid(value) {
    const { responses, addResponse } = responsesStore.getState(); 
    const appliances = findResponse(responses, 'appliances');

console.log('VALUE', value);

    const offgrid = value !== 'Include_hook-up';

    if (!offgrid) return;

console.log('OFFGRID', offgrid);

    // change all offset values to [value] where volts === 230
    const updatedAppliances = appliances.map((app) => {
        if (app.volts === '230') {
            return {
                ...app,
                offgrid: offgrid,
            };
        }
        return app;
    });

console.log('UPDATED APPLIANCES', updatedAppliances);

    addResponse({ id: 'appliances', value: updatedAppliances });
}

export function hasACAppliances(responses) {
    const appliances = findResponse(responses, 'appliances');
    return appliances.some((app) => app.volts === '230');
}
